<template>
  <div class="tabTree-wrap" v-loading="loading">
    <!-- <div class="leftTree" v-if="showCompanyList">
      <div class="lefttree">
        <p class="companyTitle">公司结构列表</p>
        <div class="topTree">
          <el-tree
            class="filter-tree"
            style="flex: 1"
            node-key="id"
            :data="treedata"
            :props="defaultCompanyProps"
            default-expand-all
            :filter-node-method="filterCompanyNode"
            :expand-on-click-node="false"
            ref="companyTree"
            @node-click="companyNodeClick"
            :highlight-current="true"
          >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span
                :title="node.label"
                class="show-ellipsis el-icon-office-building"
                >{{ node.label }}</span
              >
            </span>
          </el-tree>
        </div>
      </div>
    </div> -->
    <div class="rightTree">
      <div>
        <el-popover
          placement="bottom"
          width="240"
          trigger="click"
          @show="bindPopShow"
          @hide="bindPopShow"
        >
          <el-tree
            :data="data"
            :props="defaultProps"
            @node-click="handleNodeClick"
          ></el-tree>
          <div class="tabTree-tab" slot="reference">
            <div class="tab-title">
              {{ tabSelectedNode !== null ? tabSelectedNode.label : "" }}
            </div>
            <i
              :class="{
                'el-icon-arrow-down': !popShow,
                'el-icon-arrow-up': popShow,
              }"
            ></i>
          </div>
        </el-popover>
      </div>
      <div class="tab-tree">
        <div class="tree-top dn-content-bg" v-if="checkbox">
          <div class="top-content">
            <el-checkbox v-if="showCheckAll" v-model="checkAll"
              >全选</el-checkbox
            >
          </div>
          <el-checkbox v-if="showCascade" v-model="checkStrictly"
            >级联</el-checkbox
          >
        </div>
        <el-input
          class="input-text"
          placeholder="输入关键字进行过滤"
          v-model="filterText"
        ></el-input>
        <div class="tree">
          <el-tree
            :data="dataTree"
            ref="tabtree"
            class="tree-line"
            node-key="id"
            :highlight-current="true"
            :default-expand-all="true"
            :props="defaultProps"
            :check-strictly="!checkStrictly"
            :show-checkbox="checkbox"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            @node-click="handleMeasureNodeClick"
            @check="bindCheckChange"
          >
            <span class="span-ellipsis" slot-scope="{ node, data }">
              <span :node="node" :title="data.measureName">{{
                data.measureName
              }}</span>
            </span>
          </el-tree>
        </div>
      </div>
    </div>
    <!-- 点击外面让el-popover消失，解决el-popover下拉框选中不消失的情况 -->
    <div ref="closePopover"></div>
  </div>
</template>

<script>
import StringTool from "@/utils/stringTool.js";
import Tree from "@/utils/tree.js";
import api from "../../../../common/api/index";
import utils from "@common/utils/index.js";
export default {
  props: {
    data: {
      type: Array,
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
    maxCheckCount: {
      type: Number,
      default: -1,
    },
    /**
     * 是否级联
     */
    strictly: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示级联
     */
    showCascade: {
      type: Boolean,
      default: true,
    },
    /* 是否全选 */
    expandAll: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示全选
     */
    showCheckAll: {
      type: Boolean,
      default: true,
    },
    includeHalfChecked: {
      type: Boolean,
      default: false,
    },
    /**
     * 默认点击的计量点id
     */
    measureId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tabSelectedNode: null,
      arrTree: [],
      dataTree: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      filterText: "",
      popShow: false,
      loading: false,
      checkAll: false,
      checkStrictly: true,
      viewIds: [],
      filterCompany: "",
      treedata: [],
      defaultCompanyProps: {
        children: "children",
        label: "name",
      },
      companyId: "",
      showCompanyList: false,
    };
  },
  created() {
    this.checkStrictly = this.strictly;
    this.getCompanyInfo();
  },
  watch: {
    filterText(val) {
      this.$refs.tabtree.filter(val);
    },
    filterCompany(val) {
      this.$refs.companyTree.filter(val);
    },
    data(val) {
      let vm = this;
      if (!val.length) {
        vm.loading = false;
        vm.arrTree = [];
        vm.dataTree = [];
        return;
      }
      if (val instanceof Array) {
        //获取所有视图里面的树
        let arr = Tree.treeArrToArr(val);
        let viewParams = [];
        let viewIds = [];
        let defaultNode = null;
        for (let i = 0; i < arr.length; i++) {
          if (!StringTool.isEmpty(arr[i].id)) {
            if (viewIds.length == 0) {
              defaultNode = arr[i];
            }
            viewIds.push(arr[i].id);
            viewParams.push(api.view.getViewTreeNodes(arr[i].id));
          }
        }
        Promise.all(viewParams).then((resArr) => {
          for (let i = 0; i < resArr.length; i++) {
            //调用vuex 设置视图数据
            vm.$store.commit("viewTree/SET_VIEW_TREE_DATA", {
              viewId: viewIds[i],
              data: resArr[i].data,
            });
          }
          vm.tabSelectedNode = defaultNode;
          vm.getViewTreeData(defaultNode.id, defaultNode.pointCode);
          vm.loading = false;
        });
      }
    },
    checkAll(val) {
      if (val) {
        this.bindCheckAll();
      } else {
        this.bindNoCheckAll();
      }
    },
  },
  methods: {
    /* 获取公司树 */
    async getCompanyInfo() {
      let vm = this;
      vm.$api.user.listCompaniesOfIJoined(null, null, 1).then((res) => {
        if (res.data) {
          vm.treedata = utils.companyDataToCompanyTree(res.data);
          if (vm.treedata.length > 0) {
            let setCompanyId = vm.treedata[0].id;
            if (vm.treedata.length > 1 || vm.treedata[0].children.length > 0) {
              vm.showCompanyList = true;
            }
            vm.$emit("changeCompany", setCompanyId);
            if (vm.showCompanyList) {
              vm.$nextTick(() => {
                vm.$refs.companyTree.setCurrentKey(setCompanyId);
              });
            }
          }
        }
      });
    },
    /* 公司树点击 */
    async companyNodeClick(data) {
      this.$emit("changeCompany", data.id);
    },
    filterCompanyNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      let vm = this;
      /* 选中之后让其点击外围，让el-popover消失 */
      vm.$nextTick(() => {
        vm.$refs.closePopover.click();
      });
      if (!StringTool.isEmpty(data.id)) {
        vm.tabSelectedNode = data;
        vm.getViewTreeData(data.id, data.pointCode);
      }
    },
    getViewTreeData(viewId, pointCode) {
      let vm = this;
      //设置默认点击选中的节点
      let item = null;
      if (vm.measureId != "") {
        item = vm.findMeasureId(vm.measureId, viewId);
      } else {
        const data = vm.$store.getters[
          "viewTree/GET_VIEW_TREE_DATA_FOR_VIEWID"
        ](viewId);
        this.$emit("getTreeData", data);
        let treeData = Tree.creatTreeJson(data, "0");
        item = treeData[0];
        vm.arrTree = data;
        vm.dataTree = treeData;
      }
      //设置默认选中点
      if (!vm.checkbox) {
        this.$emit("tabTreeDefault", item, pointCode);
        vm.$nextTick(() => {
          vm.$refs.tabtree.setCurrentKey(item.id);
        });
      } else {
        this.$emit("tabTreeDefault", item, pointCode);
        vm.$nextTick(() => {
          vm.$refs.tabtree.setCheckedNodes([item], !vm.checkStrictly);
        });
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.measureName.indexOf(value) !== -1;
    },
    bindPopShow() {
      this.popShow = !this.popShow;
    },
    handleMeasureNodeClick(data) {
      this.$emit("tabTreeClick", data);
    },
    // 全选或反选
    bindCheckAll() {
      this.$refs.tabtree.setCheckedNodes(this.arrTree);

      this.bindCheckChange();
    },
    bindNoCheckAll() {
      this.$refs.tabtree.setCheckedNodes([]);
      this.bindCheckChange();
    },
    bindCheckChange() {
      let vm = this;
      let data = vm.$refs.tabtree.getCheckedNodes(false, vm.includeHalfChecked);
      let ids = [];
      //判断最大选中
      if (vm.maxCheckCount !== null) {
        if (data.length > vm.maxCheckCount && vm.maxCheckCount > -1) {
          this.$message("最多可选择" + vm.mostChecked + "个！");
          for (let index = 0; index < data.length - vm.mostChecked; index++) {
            vm.$refs.tree.setChecked(data[index].id, false, false);
            data.splice(index, 1);
          }
        }
      }
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        ids.push(element.id);
      }
      let selectNodeIdArr = vm.getTreeArrId(data);
      let selectNodeArr = vm.getTreeArr(data);
      this.$emit("change", selectNodeIdArr, ids, selectNodeArr); //反馈给父组件
    },
    getTreeArrId(data) {
      let selectNodeIdArr = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        selectNodeIdArr.push({
          id: element.id,
          label: element.label,
        });
      }
      return selectNodeIdArr;
    },
    getTreeArr(data) {
      let selectNodeIdArr = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        selectNodeIdArr.push(element);
      }
      return selectNodeIdArr;
    },

    findMeasureId(measureId, viewId) {
      let vm = this;
      let tabData = vm.data;
      vm.getViewIds(tabData);
      for (let i = 0; i < vm.viewIds.length; i++) {
        const viewId2 = vm.viewIds[i].id;
        const data = vm.$store.getters[
          "viewTree/GET_VIEW_TREE_DATA_FOR_VIEWID"
        ](viewId2);

        const measure = data.find((c) => c.measureId == measureId);
        //找到计量点
        if (measure) {
          //设置tab选中
          vm.tabSelectedNode = vm.viewIds[i];
          this.$emit("getTreeData", data);
          let treeData = Tree.creatTreeJson(data, "0");
          vm.arrTree = data;
          vm.dataTree = treeData;
          return measure;
        }
      }

      //如果没有找到
      const data = vm.$store.getters["viewTree/GET_VIEW_TREE_DATA_FOR_VIEWID"](
        viewId
      );
      this.$emit("getTreeData", data);
      let treeData = Tree.creatTreeJson(data, "0");
      vm.arrTree = data;
      vm.dataTree = treeData;
      return treeData[0];
    },

    /**
     * 获取所有的视图id
     */
    getViewIds(data) {
      for (var i in data) {
        if (data[i].id) {
          this.viewIds.push({ id: data[i].id, label: data[i].label });
        }
        if (data[i].children) {
          this.getViewIds(data[i].children);
        }
      }
    },
  },
};
</script>
<style lang="css" scoped>
.tabTree-wrap >>> .el-tree-node__content {
  padding-left: 0px;
  width: 100%;
  padding-right: 20px;
  display: flex;
  align-items: center;
}
</style>

<style lang="scss" scoped>
.tabTree-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  min-width: 200px;
  border-radius: 4px;
  overflow: hidden;
  overflow: auto;
  .leftTree {
    width: 100%;
    height: 300px;
    display: flex;
    flex-flow: column;
    min-width: 200px;
    border-radius: 4px;
    overflow: hidden;
    border-right: 2px solid #ccc;
    padding-bottom: 0;
    box-sizing: border-box;
    margin-bottom: 10px;
    .companyTitle {
      display: flex;
      padding: 0px 10px;
      line-height: 36px;
      height: 36px;
      font-weight: bold;
      font-size: 16px;
      align-items: center;
      background: #409eff;
      color: #fff;
      margin-bottom: 6px;
    }
  }
  .rightTree {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    min-width: 200px;
    border-radius: 4px;
    overflow: hidden;
  }
}
.tabTree-tab {
  display: flex;
  padding: 0px 10px;
  line-height: 36px;
  height: 36px;
  font-weight: bold;
  font-size: 16px;
  align-items: center;
  background: #fff;
  color: #333;
}
.tab-title {
  flex: 1;
  text-align: left;
}
.tab-tree {
  flex: 1;
  display: flex;
  flex-flow: column;
  overflow: auto;
}
.input-text {
  padding: 6px;
  box-sizing: border-box;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
.tree-top {
  padding: 4px;
  display: flex;
  align-items: center;
}
.top-content {
  flex: 1;
  text-align: left;
  display: flex;
  align-items: center;
}
</style>
<style scoped>
.tree {
  overflow-y: auto;
  overflow-x: auto;
  flex: 1;
  background: #fff;
}
.tree .el-tree {
  min-width: 100%;
  font-size: 14px;
  text-align: left;
  display: inline-block !important;
}
/* .tree-line{
    background: #fff;
} */
.lefttree {
  display: flex;
  flex-flow: column;
  position: relative;
  height: 100%;
  overflow: auto;
  width: 100%;
}
.show-ellipsis {
  display: flex;
  width: 280px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.topTree {
  overflow-y: auto;
  overflow-x: auto;
  flex: 1;
  background: #fff;
  display: flex;
}
</style>
